import { render, staticRenderFns } from "./AlvoradaPrevisaoUsoQuimioterapico.vue?vue&type=template&id=b05d34e4&scoped=true"
import script from "./AlvoradaPrevisaoUsoQuimioterapico.vue?vue&type=script&lang=ts"
export * from "./AlvoradaPrevisaoUsoQuimioterapico.vue?vue&type=script&lang=ts"
import style0 from "./AlvoradaPrevisaoUsoQuimioterapico.vue?vue&type=style&index=0&id=b05d34e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05d34e4",
  null
  
)

export default component.exports